import React, { memo } from "react";
import * as PropTypes from "prop-types";
import PivotTable from "../../table/PivotTable";

const ProjectedFundingGapsByGniGroupTable = props => (
  <PivotTable
    titles={[
      {
        title: "",
        columnSpan: 1
      },
      {
        title: "2020",
        columnSpan: 3,
        groupStart: true
      },
      {
        title: "2025",
        columnSpan: 3,
        groupStart: true
      }
    ]}
    columnKey="indicator"
    columnDefinitions={[
      {
        value: "Cost Share (2020)",
        label: "Cost Share",
        groupStart: true
      },
      {
        value: "Gap (2020)",
        label: "Gap"
      },
      {
        value: "Gap as % of Cost Share (2020)",
        label: "Gap as % of<br />Cost Share",
        percentage: true
      },
      {
        value: "Cost Share (2025)",
        label: "Cost Share",
        groupStart: true
      },
      {
        value: "Gap (2025)",
        label: "Gap"
      },
      {
        value: "Gap as % of Cost Share (2025)",
        label: "Gap as % of<br />Cost Share",
        percentage: true
      }
    ]}
    rowKey="area"
    rowDefinitions={[
      {
        value: "Low-Income (LIC)",
        label: "LIC"
      },
      {
        value: "Lower-Middle-Income (L-MIC)",
        label: "L-MIC"
      },
      {
        value: "Upper-Middle-Income (U-MIC)",
        label: "U-MIC"
      },
      {
        value: "Total",
        total: true
      }
    ]}
    data={props.data}
  />
);

ProjectedFundingGapsByGniGroupTable.propTypes = {
  data: PropTypes.array.isRequired
};

export default memo(ProjectedFundingGapsByGniGroupTable);
